// test2624
(2624 && 0);
